import {SVVHeading, SVVIngress} from "@komponentkassen/svv-text";
import {SessionStorageKeys, TjenesteIDer} from "../book/types";
import {useApptekster} from "../../apptekst-context";
import {Tekster} from "../../types/apptekster";
import InterfaceService from "../../interface/InterfaceService";

export const TjenesteHeading = (
    {
        headingNokkel,
        tjeneste
    }:
        {
            params?: { [p: string]: string },
            headingNokkel: keyof Tekster,
            tjeneste?: InterfaceService
        }
) => {
    const t = useApptekster();
    let tjenesteHeading = ""
    let tjenesteIngress = ""

    if (tjeneste && tjeneste.serviceId) {
        switch (tjeneste.serviceId) {
            case TjenesteIDer.TEORI:
                if (tjeneste.isTungKjoreToy) {
                    tjenesteHeading = t("timebestilling.tjenestetype.tung-teori")
                    tjenesteIngress = t("timebestilling.tjenestetype.tung-teori.forklaring")
                } else {
                    tjenesteHeading = t("timebestilling.tjenestetype.teori")
                    tjenesteIngress = t("timebestilling.tjenestetype.teori.forklaring")
                }
                break
            case TjenesteIDer.FORERKORT:
                if (tjeneste.isFartsskriverProve) {
                    tjenesteHeading = t("timebestilling.tjenestetype.fartsskriver")
                    tjenesteIngress = t("timebestilling.tjenestetype.fartsskriver.forklaring")
                } else {
                    tjenesteHeading = t("timebestilling.tjenestetype.forerkort")
                    tjenesteIngress = t("timebestilling.tjenestetype.forerkort.forklaring")
                }
                break
            case TjenesteIDer.REGISTRERING:
                tjenesteHeading = t("timebestilling.tjenestetype.registrering")
                tjenesteIngress = t("timebestilling.tjenestetype.registrering.forklaring")
                break
        }
    } else if (sessionStorage.getItem(SessionStorageKeys.SERVICE)) {
        const tjeneste = JSON.parse(sessionStorage.getItem(SessionStorageKeys.SERVICE) as string) as InterfaceService
        switch (tjeneste.serviceName.toLowerCase()) {
            case "teori":
                if (tjeneste.isTungKjoreToy) {
                    tjenesteHeading = t("timebestilling.tjenestetype.tung-teori")
                    tjenesteIngress = t("timebestilling.tjenestetype.tung-teori.forklaring")
                } else {
                    tjenesteHeading = t("timebestilling.tjenestetype.teori")
                    tjenesteIngress = t("timebestilling.tjenestetype.teori.forklaring")
                }
                break
            case "førerkort":
                if (tjeneste.isFartsskriverProve) {
                    tjenesteHeading = t("timebestilling.tjenestetype.fartsskriver")
                    tjenesteIngress = t("timebestilling.tjenestetype.fartsskriver.forklaring")
                } else {
                    tjenesteHeading = t("timebestilling.tjenestetype.forerkort")
                    tjenesteIngress = t("timebestilling.tjenestetype.forerkort.forklaring")
                }
                break
            case "registrering":
                tjenesteHeading = t("timebestilling.tjenestetype.registrering")
                tjenesteIngress = t("timebestilling.tjenestetype.registrering.forklaring")
                break
        }
    }
    return (
        <>
            <SVVHeading level="h1">
                {`${t(headingNokkel)} ${tjenesteHeading}`}
            </SVVHeading>
            <SVVIngress>
                {tjenesteIngress}
            </SVVIngress>
        </>

    )
}